"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _editorImgDrag = _interopRequireDefault(require("./components/editorImgDrag"));
var _editorVideo = _interopRequireDefault(require("./components/editorVideo"));
var _storage = require("@/api/storage");
require("../../../public/tinymce4.7.5/langs/zh_CN");
var _auth = require("@/utils/auth");
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'Tinymce',
  components: {
    editorImgDrag: _editorImgDrag.default,
    editorVideo: _editorVideo.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: Number,
      required: false,
      default: 360
    },
    width: {
      type: Number,
      required: false,
      default: 720
    },
    needAddCode: {
      type: Boolean,
      default: false
    },
    codeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id || 'vue-tinymce-' + +new Date(),
      code: '',
      uploadPath: _storage.uploadPath
    };
  },
  computed: {
    headers: function headers() {
      return {
        "Mu-Token": (0, _auth.getToken)()
      };
    }
  },
  watch: {
    value: function value(val) {
      var _this2 = this;
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(function () {
          window.tinymce.get(_this2.tinymceId).setContent(val);
        });
      }
    }
  },
  mounted: function mounted() {
    this.initTinymce();
  },
  activated: function activated() {
    this.initTinymce();
  },
  deactivated: function deactivated() {
    this.destroyTinymce();
  },
  destroyed: function destroyed() {
    this.destroyTinymce();
  },
  methods: {
    initTinymce: function initTinymce() {
      var _this3 = this;
      var _this = this;
      window.tinymce.init((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        selector: "#".concat(this.tinymceId),
        // 语言
        language: 'zh_CN',
        // 高度
        height: this.height,
        // 宽度
        width: this.width,
        // 自动转换URL:关闭
        convert_urls: false,
        plugins: "media",
        media_live_embeds: true,
        extended_valid_elements: "video[width|height|controls|src|preload|poster]",
        valid_elements: "*[*]",
        // 允许所有元素
        // 工具栏
        toolbar: ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample', 'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen', 'fontsizeselect fontselect'],
        // 字体大小
        fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
        font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;Verdana=Verdana,Geneva,sans-serif;'
      }, "plugins", ['advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount']), "init_instance_callback", function init_instance_callback(editor) {
        if (_this.value) {
          editor.setContent(_this.value);
        }
        _this.hasInit = true;
        editor.on('NodeChange Change KeyUp SetContent', function (e) {
          _this3.hasChange = true;
          _this3.$emit('input', editor.getContent());
          if (e.type === 'nodechange') {
            console.log('节点变化');
            _this3.$emit('nodechange', {
              editor: editor,
              type: e.type
            });
          } else if (e.type === 'change') {
            console.log('内容变化');
            _this3.$emit('change', {
              editor: editor,
              type: e.type
            });
            // } else if (e.type === 'keyup') {
            //   console.log('键盘弹起')
            // } else if (e.type === 'setcontent') {
            //   console.log('内容设置')
          }
        });
      }), "images_upload_handler", function images_upload_handler(blobInfo, success, failure) {
        var formData = new FormData();
        formData.append('file', blobInfo.blob());
        (0, _storage.createStorage)(formData).then(function (res) {
          success(res.data.data.url + '?imageView/2/w/600');
        }).catch(function (error) {
          failure('上传失败，请重新上传');
        });
      }), "file_picker_types", 'media'), "file_picker_callback", function file_picker_callback(cb, value, meta) {
        if (meta.filetype == 'media') {
          //创建一个隐藏的type=file的文件选择input
          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.onchange = function () {
            var file = this.files[0]; //只选取第一个文件。如果要选取全部，后面注意做修改
            // 创建 FormData 对象
            var formData = new FormData();
            formData.append("file", file); // 文件名为 "file"
            var isValid = _this.beforeUpload(file);
            if (isValid) {
              // 上传到接口
              _axios.default.post(_storage.uploadPath, formData, {
                headers: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.headers), {}, {
                  "Content-Type": "multipart/form-data" // 必须是 multipart/form-data
                })
              }).then(function (res) {
                cb(res.data.data.url);
              });
            } else {
              _this.$message.warning('请上传视频文件并不超过10M');
            }
          };
          //触发点击
          input.click();
        }
      }));
    },
    beforeUpload: function beforeUpload(file) {
      var size = file.size / 1024;
      var vides = ['mp4', 'avi', 'mov', 'rmvb', 'wmv'];
      var isVideo = vides.some(function (item) {
        return item.indexOf(file.type.split('/')[1]) >= 0;
      });
      var type = this.type;
      if (['1', '8'].includes(type)) return isVideo && size <= 10240;
      return isVideo && size <= 5120;
    },
    // 销毁编辑器
    destroyTinymce: function destroyTinymce() {
      if (window.tinymce.get(this.tinymceId)) {
        window.tinymce.get(this.tinymceId).destroy();
      }
    },
    // 设置编辑器内容
    setContent: function setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    // 获取编辑器内容
    getContent: function getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
    selectChange: function selectChange(value) {
      window.tinymce.activeEditor.execCommand('mceInsertContent', false, value.key);
    },
    // 多图上传排序成功
    imageSuccess: function imageSuccess(arr) {
      var _this = this;
      arr.forEach(function (v) {
        window.tinymce.get(_this.tinymceId).insertContent("<img class=\"wscnph\" src=\"".concat(v + '?imageView/2/w/600', "\" >"));
      });
    },
    // 视频排序成功
    videoSuccess: function videoSuccess(file) {
      var _this = this;
      var videoHtml = "<video width=\"100%\" height=\"420\" controls=\"controls\">\n                            <source src=\"".concat(file, "\" type=\"video/mp4\">\n                            Your browser does not support the video tag.\n                        </video>");
      window.tinymce.get(_this.tinymceId).insertContent(videoHtml);
    }
  }
};